import { createSlice } from "@reduxjs/toolkit";
import { reviewRolesListAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const reviewRolesSlice = createSlice({
  name: "reviewRoles",
  initialState: data,
  reducers: {
    reviewRolesSlice(state) {
      state.isLoading = true;
    },
    reviewRolesSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    reviewRolesSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    reviewRolesSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const reviewRolesHandler = () => async (dispatch: any) => {
  try {
    dispatch(reviewRolesAction.reviewRolesSlice());
    const response: any = await reviewRolesListAPI();
    dispatch(reviewRolesAction.reviewRolesSliceSuccess(response));
  } catch (e: any) {
    dispatch(reviewRolesAction.reviewRolesSliceFailure(e?.response?.data?.message));
    dispatch(reviewRolesAction.reviewRolesSliceReset());
  }
};
export default reviewRolesSlice.reducer;
export const reviewRolesAction = reviewRolesSlice.actions;
